module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2chap"
  }, [_c('a', {
    attrs: {
      "id": "ch06"
    }
  }), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("EVERYONE WORKED")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/chapter.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("A")]), _vm._v("lthough I did not understand how or why, and still cannot fully explain it, my father insisted that I move rapidly through the school system. As a result I entered high school two weeks after I turned thirteen and graduated when I was sixteen. My father was proud of my brothers’ achievements, of course, but he had not gone beyond the fourth grade, so to him learning was everything. Whenever I was in tears or dejected (or both) at not having done well in a sport, he always tried to console me: “Don’t worry about it, it’s not that important. You study hard and someday your brothers will look up to you, just like you look up to them now.” I didn’t believe him, but he did increase my incentive to do well in school.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("As far back as I can remember, everyone in our family worked: delivering newspapers, mowing lawns, washing cars, sweeping floors, shoveling snow, in textile mills and paper mills, self-employed and for others. We never talked about it; it was expected and we just did it. I still remember clearly the two most difficult jobs I had, one because it was too cold, the other too hot. I hated waking up early to deliver morning newspapers. It was dark, extremely cold in the winter, and the pile of papers we loaded into our delivery bags was heavy. I could just barely lift the bag when it was full, so the early deliveries were the hardest. Although just a few blocks long, the route seemed endless. It was a joy to get back home to a steaming cup ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("of hot chocolate. For a few years I also delivered afternoon papers, then published in Portland and Lewiston. That was much easier; there were no home deliveries. Sales were made directly, in places like Bill’s Bar, just off Front Street, where workers returning home would stop for a beer. We newsboys would burst into the bar yelling, “Portland Evening Express!” or “Lewiston Evening Journal!” as we scrambled for sales from the friendly workers.")])]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The other job that was difficult was picking beans in the summer. Large farms (or so they seemed at the time) outside of Waterville grew green beans, which were harvested in August. Kids from Waterville were bused to the farms in the morning and spent the day picking. Pay was based on the volume of beans picked, so speed was of the essence. The fastest way was to stand with your legs upright, one foot on either side of the row of beans, your back bent at a ninety-degree angle as you stooped to pick the beans and move quickly down each row. But after a short time the back pain was severe. The alternative was to crawl up and down the space between the rows on your hands and knees; that was easier on your back but much slower and less profitable. So, depending on your individual tolerance, you would stoop as long as you could, then crawl for as short a time as necessary. Inevitably the amount of stooping was greatest early in the morning; as the sun rose and the day got hotter, we (especially the younger kids like me) tired quickly and ended the day crawling ever more slowly. It was difficult work, but the few dollars we earned made a difference at home. We were fortunate that the harvest season was only a few weeks long. Many years later, as a lawyer on a business trip, I found myself standing in truly large agricultural fields in western Arizona and southern California watching migrant laborers pick vegetables under a brutally hot sun. I thought of how fortunate I was to have had to do such work for just a couple of weeks over a few summers, and I wondered if any of the children I was watching would have the same luck in their lives as I had in mine.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("I worked my way through college as a truck driver, an advertising salesman, a dormitory proctor, and a fraternity steward. I then worked full time as an insurance adjuster while attending law school at night. To me this was not remarkable. It was the way of life I learned from my parents.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71f54aa4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch06.vue
// module id = 93
// module chunks = 0